import { createActionCreator } from '@pressreader/appstore';
import { type ArticleFields, IArticle, IArticleUpdatable } from '@pressreader/content-types';
import { ArticleLoadingTags } from '@pressreader/feed-types';

import { MODULE_NAME } from '../../constants';
import { ArticleActionPayload } from '../../types/article.action.payload';

const prefix = `${MODULE_NAME}/articles/`;

export const loadArticleBegan = createActionCreator<{
    articleId: string;
    loadingTags: ArticleLoadingTags[];
    requiredFields?: ArticleFields;
}>(`${prefix}load-article-began`);

export const loadArticleDone = createActionCreator<{
    article: IArticle;
    requiredFields?: ArticleFields;
}>(`${prefix}load-article-done`);

export const loadArticleFailed = createActionCreator<ArticleActionPayload & { requiredFields?: ArticleFields }>(`${prefix}load-article-failed`);

export const articlesLoaded = createActionCreator<{
    articles: IArticle[];
}>(`${prefix}articles-loaded`);

export const articleUpdated = createActionCreator<{
    articleId: string;
    article: IArticleUpdatable;
}>(`${prefix}article-updated`);

export type ArticlesUpdatedPayloadArticleUpdate = IArticleUpdatable & { articleId: string };

export const articlesUpdated = createActionCreator<{
    articleUpdates: Array<ArticlesUpdatedPayloadArticleUpdate>;
}>(`${prefix}articles-updated`);
